//小程序端查询证书成绩配置
export function resultConfig(params) {
  return axios({
    url: '/api/results/user-certificate/result-config',
    method: 'GET',
    params
  })
}
